import getLocation from './getLocation';
export function isQa() {
  const {
    href
  } = getLocation();

  if (href.includes('hubspotqa.com') || href.includes('connectqa.co')) {
    return true;
  }

  return false;
}
export let DOMAIN_NAME;

(function (DOMAIN_NAME) {
  DOMAIN_NAME["CONNECT"] = "CONNECT";
  DOMAIN_NAME["HUBSPOT"] = "HUBSPOT";
})(DOMAIN_NAME || (DOMAIN_NAME = {}));

export let APP_NAME;

(function (APP_NAME) {
  APP_NAME["PUBLIC"] = "PUBLIC";
  APP_NAME["AUTHED"] = "AUTHED";
})(APP_NAME || (APP_NAME = {}));

export function getDomain() {
  const {
    href
  } = getLocation(); // https://regexr.com/79sah

  if (href.match(/.*connect(qa)?.com?/g)) {
    return DOMAIN_NAME.CONNECT;
  }

  return DOMAIN_NAME.HUBSPOT;
}
export function getIsLocal() {
  const {
    href
  } = getLocation();

  if (href.includes('://local')) {
    return true;
  }

  return false;
}
export function getBaseUrl() {
  const domain = getDomain();

  if (domain === DOMAIN_NAME.HUBSPOT) {
    return '/connect-public/';
  } else return '/';
} // Quick note to self that this is a bit of a nightmare due to the
// variety of domains involved:
// QA: app.hubspotqa.com, local.hubspotqa.com, connectqa.co, local.connectqa.co
// PROD: app.hubspot.com, local.hubspot.com, connect.com, local.connect.com

export function buildLink(suffix, options) {
  const suffixToAppend = `${suffix ? `${suffix}` : ''}`;
  const domainToUse = options && options.domainOverride || getDomain();

  function maybeOverrideApp(defaultApp) {
    if (options && options.hubspotAppOverride) {
      const {
        hubspotAppOverride
      } = options;

      if (hubspotAppOverride === APP_NAME.AUTHED) {
        return `connect`;
      } else if (hubspotAppOverride === APP_NAME.PUBLIC) {
        return `connect-public`;
      }
    }

    return defaultApp;
  }

  const isLocal = options && options.forceNotLocal ? false : getIsLocal();

  if (isQa()) {
    if (domainToUse === DOMAIN_NAME.HUBSPOT) {
      const prefix = isLocal ? 'local' : 'app';
      return `https://${prefix}.hubspotqa.com/${maybeOverrideApp('connect-public')}/${suffixToAppend}`;
    }

    const prefix = isLocal ? 'local' : 'www';
    return `https://${prefix}.connectqa.co/${suffixToAppend}`;
  }

  if (domainToUse === DOMAIN_NAME.HUBSPOT) {
    const prefix = isLocal ? 'local' : 'app';
    return `https://${prefix}.hubspot.com/${maybeOverrideApp('connect-public')}/${suffixToAppend}`;
  }

  const prefix = isLocal ? 'local' : 'www';
  return `https://${prefix}.connect.com/${suffixToAppend}`;
}
export const buildMemberPageLink = userName => buildLink(`member/${userName}`, {
  hubspotAppOverride: APP_NAME.AUTHED
});